var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as _ from 'lodash';
import { InputText } from "primereact/inputtext";
import * as React from 'react';
import { withRouter } from "react-router-dom";
import ApiRequests from "../../../classes/http/ApiRequests";
import HttpRequests from "../../../classes/http/HttpRequests";
import Grid from '../../../components/UI/Grid/Grid';
import AppRoutes from '../../../config/appRoutes';
var OrdersList = /** @class */ (function (_super) {
    __extends(OrdersList, _super);
    function OrdersList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.gridHeaders = [
            { name: 'Завършена на', key: 'completed_at', formatter: 'date', filter: false, sort: false },
            { name: 'Номер', key: 'number', filter: false, sort: false },
            { name: 'ID', key: 'id', filter: false, sort: false },
            { name: 'Начин на доставка', key: 'delivery_method_name', filter: false, sort: false },
            { name: 'Начин на плащане', key: 'payment_method_name', filter: false, sort: false },
            { name: 'Email', key: 'email', filter: false, sort: false },
            { name: 'Статус', key: 'erp_document_state', filter: false, sort: false },
            { name: 'Тотал', key: 'total', filter: false, sort: false },
            { name: 'Поета', key: 'assigned', filter: false, sort: false },
        ];
        _this.viewOrder = function (rowItem) {
            var selectedNum = _.get(rowItem, 'number', '');
            if (selectedNum) {
                _this.props.history.push(AppRoutes.order.path.replace(':num', selectedNum));
            }
        };
        _this.onPage = function (event) {
            _this.props.changePage(event.page + 1);
        };
        return _this;
    }
    OrdersList.prototype.render = function () {
        var _a = this.props, gridData = _a.gridData, meta = _a.meta, search = _a.search;
        var header = (React.createElement("div", { style: { 'textAlign': 'left' } },
            React.createElement("i", { className: "pi pi-search", style: { margin: '4px 4px 0 0' } }),
            React.createElement(InputText, { type: "search", onInput: search, placeholder: "\u0422\u044A\u0440\u0441\u0435\u043D\u0435" })));
        return (React.createElement(Grid, { data: gridData, columns: this.gridHeaders, emptyMessage: '', paginator: true, total: _.get(meta, 'total_records', 0), rows: _.get(meta, 'per_page', 0), first: (_.get(meta, 'current_page', 0) - 1) * _.get(meta, 'per_page', 0), onPage: this.onPage, lazy: true, header: header, viewAction: this.viewOrder }));
    };
    return OrdersList;
}(React.Component));
// @ts-ignore
export default withRouter(OrdersList);



//////////////////
// WEBPACK FOOTER
// ./src/components/Orders/OrdersList/OrdersList.tsx
// module id = 122
// module chunks = 0